module.exports = __webpack_public_path__ + "static/media/powerEarth.ec584bb1.png";